import AdminLogout from './AdminLogout';
export default AdminLogout;